import React, { Component } from 'react';

class PanelQuestions extends Component {
    getClassName = () => {
        if(!this.props.answered) {
            return 'is-active';
        }
        return '';
    }

    render() {
        return (
            <div className="quiz__panel quiz__panel--question">
                <h2 className={`quiz__question ${this.getClassName()}`}>{this.props.question}</h2>
            </div>
        );
    }
}

export default PanelQuestions;